// eslint-disable-next-line import/prefer-default-export
export const getSwatchContainer = state => state.dimensions.swatch;



// WEBPACK FOOTER //
// ./src/store/dimensions/selector.js